import {
  RecruiterOptOut,
  RecruiterOptOutPostAjaxResponse,
} from './recruiter-opt-out.model';

export function transformRecruiterOptOut(
  recruiterOptOut: RecruiterOptOutPostAjaxResponse,
): RecruiterOptOut {
  return {
    id: recruiterOptOut.id,
    keepFreeUpgrade: recruiterOptOut.keepFreeUpgrade,
  };
}
